import { observer } from 'mobx-react';
import * as React from 'react';
import { checkedStatus } from './Selection';
import { T } from '../../../../../../../Translations';
import { EitherLearningCollectionStore, ProductLicenseResource } from '../../../../../Types';

interface Props {
  store: EitherLearningCollectionStore;
  activeProductLicense: ProductLicenseResource;
  radioId: string;
}

const LicenseAction: React.FC<Props> = ({ store, activeProductLicense, radioId }) => {
  switch (activeProductLicense.payload.productType) {
    case 'Core':
      return (
        <input
          type="radio"
          id={radioId}
          name="selectedLearningDesign"
          value={activeProductLicense.payload.id}
          className="inline-block h-5 w-5 mt-[2.5px] mr-3 text-teal-600"
          checked={checkedStatus(store.selectedProductLicense, activeProductLicense)}
          data-intercom-target="active-selected-learning-design"
          readOnly
        />
      );
    case 'Add-on':
      return (
        <div className="mr-2 text-yellow-600">
          <T kind="Add-on" />
        </div>
      );
  }
};

export default observer(LicenseAction);
